import Echo from 'laravel-echo';

import Pusher from 'pusher-js';

// Canonical, single Echo bootstrap. Guarded so loading more than one Vite
// entry on the same page (e.g. app.js + user-status.js) never re-initialises it.
if (typeof window.Echo === 'undefined') {
    window.Pusher = Pusher;

    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
        wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
        wsPath: import.meta.env.VITE_REVERB_PATH ?? "/",
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
    });
}
